<!-- KPI Vertical Funnel Component -->
<ng-container *ngIf="isDataSetLoaded; else placeholderViewContainer">
  <div class="vertical-funnel-element" [class.no-metrics]="!shouldShowMetrics()" [class.with-metrics]="shouldShowMetrics()">
    <!-- Left: Funnel Chart (fixed 700px width) -->
    <div class="funnel-container">
      <div [chart]="funnelChart" style="width: 100%;"></div>
    </div>

    <!-- Right: Metrics Grid (3×2 grid layout) -->
    <!-- Always create the grid in DOM but hide it with CSS when needed -->
    <div class="metrics-grid" [class.hide-metrics]="!shouldShowMetrics()">
      <div *ngFor="let metric of rightSideMetrics; let i = index" 
           class="metric-cell metric-index-{{i}}"
           [class.last-row]="i === rightSideMetrics.length - 1">

        <div class="metric-title">{{ metric.title }}</div>

        <!-- Simple KPI Metric -->
        <div *ngIf="!metric.isComposite; else pieSlot" class="metric-inner">
          <div class="metric-content">
            <span class="metric-value">{{ metric.value }}</span>
            <i [ngClass]="[
                getTrendArrowIconClass(metric),
                getTrendIconColor(metric),
                'arrow-icon'
              ]"></i>
          </div>

          <div class="box-label">
            <span class="subtitle-label">{{'Prev. Period' | translate | async}}:</span>
            <span class="subtitle-value">{{ metric.trendLabel }}</span>
          </div>
        </div>

        <!-- Pie Chart Metric -->
        <ng-template #pieSlot>
          <div [chart]="pieChart" class="composite-chart"></div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-container>

<!-- Placeholder Container -->
<ng-template #placeholderViewContainer>  <!-- Show placeholder view - we initialize containerWidthInitialized earlier in the lifecycle now -->
  <ng-container *ngTemplateOutlet="placeholderView"></ng-container>
</ng-template>

<!-- Placeholder View -->
<ng-template #placeholderView>  <div class="vertical-funnel-element" [class.no-metrics]="!shouldShowMetrics()" [class.with-metrics]="shouldShowMetrics()">
    <!-- Left: Placeholder Funnel -->
    <div class="funnel-container">
      <div [chart]="funnelPlaceholderChart" syncPulse style="width: 100%;"></div>
    </div><!-- Right: Placeholder Metric Cards -->
    <div class="metrics-grid" [class.hide-metrics]="!shouldShowMetrics()">
      <div *ngFor="let metric of placeholderMetrics; let i = index" class="metric-cell metric-index-{{i}}"
        [class.last-row]="i === placeholderMetrics.length - 1">

        <!-- Title Placeholder -->
        <div class="metric-title placeholder-title" syncPulse></div>

        <!-- KPI Placeholder -->
        <ng-container *ngIf="!metric.isComposite; else piePlaceholderSlot">
          <!-- Value + Icon -->
          <div class="metric-content">
            <div class="metric-value placeholder-value" syncPulse></div>
            <div class="arrow-icon placeholder-icon" syncPulse></div>
          </div>

          <!-- Prev. Period -->
          <div class="box-label">
            <span class="subtitle-label placeholder-subtitle" syncPulse></span>
            <span class="subtitle-value placeholder-subtitle-value" syncPulse></span>
          </div>
        </ng-container>

        <!-- Pie Placeholder Slot -->
        <ng-template #piePlaceholderSlot>
          <div [chart]="piePlaceholderChart" syncPulse class="composite-chart"></div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>